import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  IconButton,
  Button,
  Tooltip,
  FormLabel,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { MathEditor } from "./MathLive";
import { MathEqn } from "./icons";
import { useEffect, useState } from "react";

const EQN_OPTIONS = [
  { value: "Inline", label: "Inline" },
  { value: "Equation", label: "Equation" },
  { value: "Equationarray", label: "Equation Array" },
  { value: "unnumberedInline", label: "Unnumbered Inline" },
  { value: "unnumberedEquation", label: "Unnumbered Equation" },
  { value: "unnumberedEquationarray", label: "Unnumbered Equation Array" },
];

export function InsertMath(props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [mathVal, setMathVal] = useState("");
  const [eqnValue, setEqnValue] = useState("Inline");

  useEffect(() => {
    setMathVal("");
  }, [isOpen]);

  const selectedLabel = EQN_OPTIONS.find(o => o.value === eqnValue)?.label || eqnValue;

  const handleInsert = () => {
    const val = moveContentToNextLine(mathVal);
    const map = {
      Inline: `$${val}$`,
      Equation: `\\begin{equation}\n${val}\n\\end{equation}`,
      Equationarray: `\\begin{eqnarray}\n${val}\n\\end{eqnarray}`,
      unnumberedInline: `$$${val}$$`,
      unnumberedEquation: `\\begin{equation*}\n${val}\n\\end{equation*}`,
      unnumberedEquationarray: `\\begin{eqnarray*}\n${val}\n\\end{eqnarray*}`,
    };
    props.insertMath(map[eqnValue] || val);
    onClose();
  };

  return (
    <>
      <Tooltip label="Enter Math">
        <IconButton
          id="insertMathBtn"
          onClick={onOpen}
          fontSize="1xl"
          color="black"
          size="lg"
          colorScheme="var(--editor-bg)"
          aria-label="Insert math equation"
          icon={<MathEqn />}
          _hover={{ bg: "var(--editor-hover)" }}
        />
      </Tooltip>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="md"
        closeOnOverlayClick={false}
        useInert={false}
        trapFocus={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Insert Math Equation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormLabel>Equation Type :</FormLabel>

            {/* ── Custom dropdown — stays inside modal ── */}
            <Menu matchWidth>
              <MenuButton
                as={Button}
                rightIcon={<ChevronDownIcon />}
                width="100%"
                mb={4}
                textAlign="left"
                variant="outline"
                fontWeight="normal"
                bg="white"
                color="#333"
                borderColor="#e2e8f0"
                _hover={{ borderColor: "#3498db" }}
              >
                {selectedLabel}
              </MenuButton>
              <MenuList
                maxHeight="140px"
                overflowY="auto"
                zIndex={9999}
                width="100%"
              >
                {EQN_OPTIONS.map((opt) => (
                  <MenuItem
                    key={opt.value}
                    onClick={() => setEqnValue(opt.value)}
                    bg={eqnValue === opt.value ? "#e8f0fe" : "white"}
                    fontWeight={eqnValue === opt.value ? "600" : "normal"}
                    _hover={{ bg: "#f0f4ff" }}
                  >
                    {opt.label}
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>

            <MathEditor
              value={mathVal}
              onChange={setMathVal}
              options={{ virtualKeyboardMode: "manual", sounds: false }}
              containerStyle={{ border: "solid 1px" }}
            />
          </ModalBody>

          <ModalFooter gap={2}>
            <Button onClick={handleInsert} colorScheme="blue">
              Insert Math
            </Button>
            <Button
              variant="ghost"
              _hover={{ color: "var(--input-text)", bg: "var(--border)" }}
              color="var(--text-primary)"
              mr={3}
              onClick={onClose}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

function moveContentToNextLine(data) {
  return data.replace(/\\\\/g, "\\\\\n");
}